import { TRAVELER_DETAILS } from '../../../constants/formNamesConstants';

export const getPersistedFormData = (
  inputId: string,
): // The type below is the result of the findings on where this is set on sessionStorage which can be found on file persistData.js.
// From there we can track it's usages to CheckboxWithLabel.jsx Country.jsx Phone.jsx and Topic.jsx
| undefined
  | boolean
  | string
  | { label: string; value: string }
  | { id: any; isSelected: boolean; label: string; phoneCountryPrefix: string; value: string } => {
  const persistedFormData = sessionStorage.getItem(TRAVELER_DETAILS) || '{}';
  return JSON.parse(persistedFormData)[inputId];
};
